"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/InfoTab/MembersSection/TeamMembersList/MemberItem.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');



var _entities = require('shared/transforms/entities');
var _hooks = require('web/services/hooks');





var _Tooltip = require('web/components/Tooltip');
var _Name = require('web/components/Name'); var _Name2 = _interopRequireDefault(_Name);
var _Avatar = require('web/components/Avatar');
var _keyboard = require('web/services/keyboard');











const MemberItem = ({
  userKey,
  orgKey,
  onRemoveMember,
  openedOptionsUserKey,
  onOpenOptions,
  onCloseOptions,
  canEditParticipants,
}) => {
  const org = _hooks.useAppSelector.call(void 0, state => _org.selectOrgByKey.call(void 0, orgKey, state))
  const user = _hooks.useAppSelector.call(void 0, state => _peers.selectUserByKey.call(void 0, state, userKey))
  const userEntity = _react.useMemo.call(void 0, 
    () => {
      // SAFETY: the one key is orgKey, and its value is the org stored under it.
      const orgsMap = org ? { [orgKey]: org }  : {}
      return user && _entities.mapUserToEntity.call(void 0, 
        orgsMap,
        _entities.makeSpecificOrgTitleUserDescription.call(void 0, orgKey),
      )(user)
    },
    [org, orgKey, user],
  )

  if (!userEntity) return null

  const tooltipContent = (
    _react2.default.createElement(_Tooltip.TooltipContent, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
      , _react2.default.createElement(_Tooltip.TooltipItem, {
        'aria-label': `Remove ${userEntity.name} from team`,
        onClick: () => onRemoveMember(userKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
, "Remove from team"

      )
    )
  )

  return (
    _react2.default.createElement('div', {
      role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
      onClick: () => _actions2.default.gotoUserPage(orgKey, userKey),
      className: "directory-page--user-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}

      , _react2.default.createElement(_Avatar.UserAvatar, { userKey: userKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )
      , _react2.default.createElement('div', { className: "directory-page--user-item--metadata", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
        , _react2.default.createElement(_Name2.default, {
          orgKey: orgKey,
          className: "directory-page--user-item--name",
          user: userEntity.wrappedEntity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}
        )
        , _react2.default.createElement('div', { className: "directory-page--user-item--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
          ,  userEntity.description 
        )
      )
      ,  canEditParticipants && (
        _react2.default.createElement(_Tooltip.ControlledTooltip, {
          isDismissibleByClickElsewhere: true,
          onClose: onCloseOptions,
          isOpen: userKey === openedOptionsUserKey,
          place: "bottom",
          content: tooltipContent,
          className: "inbox-participants--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}

          , _react2.default.createElement('img', {
            onClick: evt => {
              evt.stopPropagation()
              onOpenOptions(userKey)
            },
            role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
            src: "/assets/icons/more-hor-black.svg",
            alt: "Member options" ,
            'aria-label': `${userEntity.name} options`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, MemberItem)
